import { AccountStorage } from "../generated/types";

export const useAccountStorage = () => {
  const setAccountStorage = (data: AccountStorage) => {
    localStorage.setItem("accountStorage", JSON.stringify(data));
  };

  const getAccountStorage = (): AccountStorage | null => {
    const data = localStorage.getItem("accountStorage");
    return data ? JSON.parse(data) : null;
  };

  const clearAccountStorage = () => {
    localStorage.removeItem("accountStorage");
  };

  return { setAccountStorage, getAccountStorage, clearAccountStorage };
};
